import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { HeaderComponent } from '../core/components/header/header.component';
import { SidebarComponent } from '../core/components/sidebar/sidebar.component';
import { YopaLogoComponent } from './components/yopa-logo/yopa-logo.component';
import { FormsModule } from '@angular/forms';
import { HeaderLightComponent } from '../core/components/header-light/header-light.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ImageSliderComponent } from './components/image-slider/image-slider.component';
import { HostDetailsComponent } from './components/host-details/host-details.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { LoaderComponent } from './components/loader/loader.component';
import { PostcodeLookupComponent } from './components/postcode-lookup/postcode-lookup.component';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { InfoBlockWithButtonComponent } from './components/info-block-with-button/info-block-with-button.component';
import { PropertyCardComponent } from './components/property-card/property-card.component';
import { PriceQualifierPipe } from './pipes/price-qualifier/price-qualifier.pipe';
import { GbpCurrencyPipe } from './pipes/gbp-currency/gbp-currency.pipe';
import { PageTabsComponent } from './components/page-tabs/page-tabs.component';
import { DpDatePickerModule } from 'ng2-date-picker';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { PasswordInputWithValidationComponent } from './components/password-input-with-validation/password-input-with-validation.component';
import { PropertyTypePipe } from './pipes/property-type/property-type.pipe';
import { ButtonLoaderDirective } from './directives/button-loader.directive';
import { VerifyDeviceComponent } from './components/login-form/verify-device/verify-device.component';
import { TableColumnSortComponent } from './components/table-column-sort/table-column-sort.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { SmallTabsComponent } from './components/small-tabs/small-tabs.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { PersonalTitles } from './classes/personal-titles.class';
import { RadioButtonsWithDropdownComponent } from './components/radio-buttons-with-dropdown/radio-buttons-with-dropdown.component';
import { ExpandableInformationBoxComponent } from './components/expandable-information-box/expandable-information-box.component';
import { MultipleSelectButtonComponent } from './components/multiple-select-button/multiple-select-button.component';
import { InputDatepickerComponent } from './components/input-datepicker/input-datepicker.component';
import { DropdownWithSearchComponent } from './components/dropdown-with-search/dropdown-with-search.component';
import { SearchFilterPipe } from './pipes/search-filter/search-filter.pipe';
import { CapitalizeNamesPipe } from './pipes/capitalize-names/capitalize-names.pipe';
import { LiveAgentComponent } from '../core/components/live-agent/live-agent.component';
import { PropertyDetailsComponent } from './components/property-details/property-details.component';
import { TooltipModule } from '@amin-karimi/ng2-tooltip-directive';
import { NonPropertyTypes } from './classes/non-property-types.class';
import { InputWithAutocompleteComponent } from './components/input-with-autocomplete/input-with-autocomplete.component';
import { DraggableBoxComponent } from './components/draggable-box/draggable-box.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ChipListComponent } from './components/chip-list/chip-list.component';
import { NotesComponent } from './components/notes/notes.component';
import { SortArrayPipe } from './pipes/sort-array/sort-array.pipe';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from './components/modal/modal.component';
import { InputCurrencyWrapperComponent } from './components/input-currency-wrapper/input-currency-wrapper.component';
import { InputDateComponent } from './components/input-date/input-date.component';
import { DateInputComponent } from './components/date-input/date-input.component';
import { DragDropSortListComponent } from './components/drag-drop-sort-list/drag-drop-sort-list.component';
import { DropdownListComponent } from './components/drop-downs/drop-down-list/drop-down-list.component';
import { TimesIntervalDropdownPickerComponent } from './components/times-interval-dropdown-picker/times-interval-dropdown-picker.component';
import { TrustboxComponent } from './components/trustbox/trustbox.component';
import { ImageInputFieldComponent } from './components/image-input-field/image-input-field.component';
import { ThirdPartyPropertyCardComponent } from './components/third-party-property-card/third-party-property-card.component';
import { RadioButtonGroupComponent } from './components/radio-button-group/radio-button-group.component';
import { FormValidationErrorCheckComponent } from './components/form-validation-error-check/form-validation-error-check.component';
import { FormValidationDirective } from './directives/form-validation.directive';
import { KeepNumbersOnlyDirective } from '../modules/amplify/book-valuation/directives/keep-numbers-only.directive';
import { ListDropDownSelectComponent } from './components/drop-downs/list-drop-down-select/list-drop-down-select.component';
import { UserDropdownComponent } from './components/user-dropdown/user-dropdown.component';
import { TruncateNamePipe } from './pipes/truncate-name/truncate-name.pipe';

@NgModule({
  declarations: [
    UserDropdownComponent,
    ListDropDownSelectComponent,
    HeaderComponent,
    HeaderLightComponent,
    SidebarComponent,
    YopaLogoComponent,
    ImageSliderComponent,
    HostDetailsComponent,
    PostcodeLookupComponent,
    ClickOutsideDirective,
    InfoBlockWithButtonComponent,
    PropertyCardComponent,
    PriceQualifierPipe,
    PropertyTypePipe,
    PageTabsComponent,
    LoginFormComponent,
    PasswordInputWithValidationComponent,
    VerifyDeviceComponent,
    AccordionComponent,
    ExpandableInformationBoxComponent,
    MultipleSelectButtonComponent,
    DropdownWithSearchComponent,
    SearchFilterPipe,
    CapitalizeNamesPipe,
    LiveAgentComponent,
    PropertyDetailsComponent,
    InputWithAutocompleteComponent,
    PropertyDetailsComponent,
    DraggableBoxComponent,
    InputWithAutocompleteComponent,
    ChipListComponent,
    NotesComponent,
    SortArrayPipe,
    InputCurrencyWrapperComponent,
    InputDateComponent,
    DateInputComponent,
    DragDropSortListComponent,
    TimesIntervalDropdownPickerComponent,
    TrustboxComponent,
    ImageInputFieldComponent,
    ThirdPartyPropertyCardComponent,
    RadioButtonsWithDropdownComponent,
    RadioButtonGroupComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule.withConfig({
      // This enables us use [disabled]/[attr.disabled] in HTML
      // https://github.com/angular/angular/issues/48350#issuecomment-1421279896
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    GoogleMapsModule,
    RouterModule,
    NgbCarouselModule,
    DpDatePickerModule,
    FormsModule,
    DragDropModule,
    TooltipModule.forRoot({
      hideDelay: 0,
      tooltipClass: 'tooltip-yellow',
    }),
    ButtonLoaderDirective,
    FormValidationErrorCheckComponent,
    LoaderComponent,
    ModalComponent,
    FormValidationDirective,
    KeepNumbersOnlyDirective,
    TableColumnSortComponent,
    PaginationComponent,
    SmallTabsComponent,
    InputDatepickerComponent,
    DropdownListComponent,
    GbpCurrencyPipe,
    TruncateNamePipe,
  ],
    exports: [
        KeepNumbersOnlyDirective,
        HeaderComponent,
        HeaderLightComponent,
        SidebarComponent,
        DragDropModule,
        YopaLogoComponent,
        UserDropdownComponent,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ImageSliderComponent,
        HostDetailsComponent,
        GoogleMapsModule,
        LoaderComponent,
        PostcodeLookupComponent,
        InfoBlockWithButtonComponent,
        ClickOutsideDirective,
        ListDropDownSelectComponent,
        PropertyCardComponent,
        PageTabsComponent,
        RadioButtonGroupComponent,
        PageTabsComponent,
        LoginFormComponent,
        PasswordInputWithValidationComponent,
        ButtonLoaderDirective,
        TableColumnSortComponent,
        PaginationComponent,
        SmallTabsComponent,
        AccordionComponent,
        PaginationComponent,
        RadioButtonsWithDropdownComponent,
        ExpandableInformationBoxComponent,
        MultipleSelectButtonComponent,
        InputDatepickerComponent,
        DropdownWithSearchComponent,
        PropertyDetailsComponent,
        LiveAgentComponent,
        InputWithAutocompleteComponent,
        ChipListComponent,
        PropertyDetailsComponent,
        DraggableBoxComponent,
        NotesComponent,
        ModalComponent,
        InputCurrencyWrapperComponent,
        InputDateComponent,
        DateInputComponent,
        DragDropSortListComponent,
        DropdownListComponent,
        TimesIntervalDropdownPickerComponent,
        TrustboxComponent,
        ImageInputFieldComponent,
        ThirdPartyPropertyCardComponent,
        RadioButtonGroupComponent,
        FormValidationErrorCheckComponent,
        GbpCurrencyPipe,
        PropertyTypePipe,
        TruncateNamePipe
    ],
  providers: [
    CurrencyPipe,
    PriceQualifierPipe,
    GbpCurrencyPipe,
    PropertyTypePipe,
    PersonalTitles,
    PropertyTypePipe,
    SearchFilterPipe,
    CapitalizeNamesPipe,
    NonPropertyTypes,
    SortArrayPipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
